module.exports = __webpack_public_path__ + "img/Break-the-Faith-cover.16f4d7e6.jpg";